import styled, { css } from 'styled-components';

export const Section = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.sz.s6};
    padding-bottom: ${theme.sz.s6};
    background-color: ${theme.co.secondary99};
    box-shadow: 0 0 0 100vmax ${theme.co.secondary99};
    clip-path: inset(0 -100vmax);

    & > :last-child {
      margin-bottom: ${theme.sz.s0};
    }

    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s12};
      padding-bottom: ${theme.sz.s12};
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s8};
    ${theme.typography.heading.mobile.m};

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s10};
      ${theme.typography.heading.desktop.l};
    }
  `,
);

export const Link = styled.a(
  ({ theme }) => css`
    color: ${theme.co.information30};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  `,
);
